import { TableFilterTypes, Capability, PermissionScope } from '@ge/models/constants';

export const EventManagementColumns = {
  GROUP_EVENTS: 'group-events',
  EVENT_MAP: 'eventmap',
  EVENT_CODE: 'code',
  EVENT_NAME: 'name',
  GROUP_SITE: 'group-site',
  INCLUDED_SITES: 'includedsites',
  EXCLUDED_SITES: 'excludedsites',
  GROUP_ASSET: 'group-asset',
  MAX_REST_LIMIT: 'maxResetLimit',
  PRESENTATION_DELAY: 'presentationDelay',
  CASE_CREATION_DELAY: 'caseCreationDelay',
  FLAGGED_STATES: 'flaggedStates',
  BLOCK_AUTOMATION: 'blockAutomation',
  BLOCK_CASE_ESCALATION: 'blockCaseEscalation',
  BLOCK_ALL_COMMANDS: 'blockCommands',
  ACK_RESET_COMMAND: 'ackResetCommand',
  GROUP_DESCRIPTION: 'group-description',
  DESCRIPTION: 'eventRemarks',
  GROUP_DETAIL: 'group-detail',
  EVENT_DETAIL: 'event-detail',
  EVENT_SEVERITY: 'event-severity',
  GROUP_NOTES: 'group-notes',
  EVENT_NOTES: 'notes',
  GROUP_PROCEDURE_HANDLING: 'group-procedure-handling',
  PROCEDURE_HANDLING_NAME: 'procedurehandling',
  GROUP_SEQUENCE_NAME: 'group-automation-sequence',
  AUTOMATION_SEQUENCE_NAME: 'automationsequence',
  PARENT_EVENTS: 'parentEventIds',
  CHILD_EVENTS: 'childEventIds',
  GROUP_SF_CASE: 'group-sf-case',
  CASE_DESCRIPTION: 'caseDescription',
  CASE_DISPOSITION_SUBJECT: 'caseDispositionSubject',
  CASE_DISPOSITION_NOTE: 'caseDispositionNote',
};

export const EventManagementColumnsFiltersArrayType = [
  EventManagementColumns.INCLUDED_SITES,
  EventManagementColumns.EXCLUDED_SITES,
];

// Define all available columns in the events table.
export const EventManagementColumnsDefs = {
  [EventManagementColumns.GROUP_EVENTS]: {
    labels: [
      {
        a11yKey: '',
        a11yDefault: 'EVENTS',
      },
    ],
    cols: {
      [EventManagementColumns.EVENT_CODE]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '50px',
        align: 'left',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Event Code',
            sortValue: 'code',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.EVENT_MAP]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '50px',
        align: 'left',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Event Map',
            sortValue: 'eventMapName',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.EVENT_SEVERITY]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '50px',
        align: 'left',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Severity',
            sortValue: 'eventClass',
          },
        ],
      },
      [EventManagementColumns.EVENT_NAME]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '200px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Event Name',
            sortValue: 'name',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.PARENT_EVENTS]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '200px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Parent Events',
            sortValue: 'parentEventIdsStr',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.CHILD_EVENTS]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '200px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Child Events',
            sortValue: 'childEventIdsStr',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
    },
  },
  [EventManagementColumns.GROUP_SITE]: {
    labels: [
      {
        a11yKey: '',
        a11yDefault: 'SITES',
      },
    ],
    cols: {
      [EventManagementColumns.INCLUDED_SITES]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '150px',
        align: 'left',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Included\nSites',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.EXCLUDED_SITES]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '150px',
        align: 'left',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Excluded\nSites',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
    },
  },
  [EventManagementColumns.GROUP_ASSET]: {
    labels: [
      {
        a11yKey: '',
        a11yDefault: 'ASSET',
      },
    ],
    cols: {
      [EventManagementColumns.MAX_REST_LIMIT]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '70px',
        align: 'left',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Max Reset Limit',
            sortValue: 'commandProperties.maxResetLimit',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.PRESENTATION_DELAY]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '70px',
        align: 'left',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Presentation Delay (SS)',
            sortValue: 'presentationDelay',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      // commenting, as this will be enable in future for case delay feature
      // [EventManagementColumns.CASE_CREATION_DELAY]: {
      //   capabilities: [
      //     { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
      //   ],
      //   width: '70px',
      //   align: 'left',
      //   whiteSpace: 'wrap',
      //   labels: [
      //     {
      //       a11yKey: '',
      //       a11yDefault: 'Case Creation Delay',
      //       sortValue: 'commandProperties.caseCreationDelay',
      //     },
      //   ],
      //   filterType: TableFilterTypes.CHECKBOXES,
      // },
      [EventManagementColumns.FLAGGED_STATES]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '210px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Flagged States',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.BLOCK_AUTOMATION]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '50px',
        align: 'center',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Block Automation',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.BLOCK_CASE_ESCALATION]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '50px',
        align: 'center',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Block Case Escalation',
            sortValue: 'automationProperties.blockCaseEscalation',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
        filterOptions: [
          { label: 'True', value: true },
          { label: 'False', value: false },
        ],

      },
      [EventManagementColumns.BLOCK_ALL_COMMANDS]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '50px',
        align: 'center',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Block All Commands',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.ACK_RESET_COMMAND]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '110px',
        align: 'center',
        whiteSpace: 'wrap',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Remote Acknowledge Reset Command',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
    },
  },
  [EventManagementColumns.GROUP_DESCRIPTION]: {
    cols: {
      [EventManagementColumns.DESCRIPTION]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '300px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Description',
            sortValue: 'eventRemarks',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
    },
  },
  [EventManagementColumns.GROUP_NOTES]: {
    cols: {
      [EventManagementColumns.EVENT_NOTES]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '300px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Notes',
            sortValue: 'note',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
    },
  },
  [EventManagementColumns.GROUP_PROCEDURE_HANDLING]: {
    cols: {
      [EventManagementColumns.PROCEDURE_HANDLING_NAME]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '300px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Assigned Handling Procedures',
            sortValue: 'procProperties.procTitle',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
    },
  },
  [EventManagementColumns.GROUP_SEQUENCE_NAME]: {
    cols: {
      [EventManagementColumns.AUTOMATION_SEQUENCE_NAME]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '250px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Assigned Automation Sequences',
            sortValue: 'sequenceName',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
    },
  },
  [EventManagementColumns.GROUP_SF_CASE]: {
    labels: [
      {
        a11yKey: '',
        a11yDefault: 'SF CASE DEFAULTS',
      },
    ],
    cols: {
      [EventManagementColumns.CASE_DESCRIPTION]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '200px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Case Description',
            sortValue: 'caseDescription',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.CASE_DISPOSITION_SUBJECT]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '200px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Disposition Subject',
            sortValue: 'caseDispositionSubject',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
      [EventManagementColumns.CASE_DISPOSITION_NOTE]: {
        capabilities: [
          { capability: Capability.NOTIFICATION_LIST, scopes: [PermissionScope.VIEW] },
        ],
        width: '200px',
        align: 'left',
        labels: [
          {
            a11yKey: '',
            a11yDefault: 'Disposition Note',
            sortValue: 'caseDispositionNote',
          },
        ],
        filterType: TableFilterTypes.CHECKBOXES,
      },
    },
  },
};

// Define the default visible columns and their order.
export const defaultEventManagementColumns = [
  {
    id: EventManagementColumns.GROUP_EVENTS,
    cols: [
      {
        id: EventManagementColumns.EVENT_MAP,
        visible: true,
      },
      {
        id: EventManagementColumns.EVENT_CODE,
        visible: true,
      },
      {
        id: EventManagementColumns.EVENT_SEVERITY,
        visible: true,
      },
      {
        id: EventManagementColumns.EVENT_NAME,
        visible: true,
      },
      {
        id: EventManagementColumns.PARENT_EVENTS,
        visible: true,
      },
      {
        id: EventManagementColumns.CHILD_EVENTS,
        visible: true,
      },
    ],
  },
  {
    id: EventManagementColumns.GROUP_SITE,
    cols: [
      {
        id: EventManagementColumns.INCLUDED_SITES,
        visible: true,
      },
      {
        id: EventManagementColumns.EXCLUDED_SITES,
        visible: true,
      },
    ],
  },
  {
    id: EventManagementColumns.GROUP_ASSET,
    cols: [
      {
        id: EventManagementColumns.MAX_REST_LIMIT,
        visible: true,
      },
      {
        id: EventManagementColumns.PRESENTATION_DELAY,
        visible: true,
      },
      {
        id: EventManagementColumns.CASE_CREATION_DELAY,
        visible: true,
      },
      {
        id: EventManagementColumns.FLAGGED_STATES,
        visible: true,
      },
      {
        id: EventManagementColumns.BLOCK_AUTOMATION,
        visible: true,
      },
      {
        id: EventManagementColumns.BLOCK_CASE_ESCALATION,
        visible: true,
      },
      {
        id: EventManagementColumns.BLOCK_ALL_COMMANDS,
        visible: true,
      },
      {
        id: EventManagementColumns.ACK_RESET_COMMAND,
        visible: false,
      },
    ],
  },
  {
    id: EventManagementColumns.GROUP_DESCRIPTION,
    cols: [
      {
        id: EventManagementColumns.DESCRIPTION,
        visible: true,
      },
    ],
  },
  {
    id: EventManagementColumns.GROUP_NOTES,
    cols: [
      {
        id: EventManagementColumns.EVENT_NOTES,
        visible: true,
      },
    ],
  },
  {
    id: EventManagementColumns.GROUP_PROCEDURE_HANDLING,
    cols: [
      {
        id: EventManagementColumns.PROCEDURE_HANDLING_NAME,
        visible: true,
      },
    ],
  },
  {
    id: EventManagementColumns.GROUP_SF_CASE,
    cols: [
      {
        id: EventManagementColumns.CASE_DESCRIPTION,
        visible: true,
      },
      {
        id: EventManagementColumns.CASE_DISPOSITION_SUBJECT,
        visible: true,
      },
      {
        id: EventManagementColumns.CASE_DISPOSITION_NOTE,
        visible: true,
      },
    ],
  },
];
